import http from "./http-common";

import authHeader from "./auth-header";

const register = (fullname, email, wa, password) => {
  return http.post("/auth/signup", {
    fullname,
    email,
    wa,
    password,
  });
};

const login = async (email, password, token) => {
  const response = await http.post("/auth/signin", {
    email,
    password,
    token,
  });
  if (response.data.accessToken) {
    localStorage.setItem("user", JSON.stringify(response.data));
  }
  return response.data;
};

const otp_email = (email) => {
  return http.post("/auth/otp_email", {
    email,
  });
};

const otp_wa = (wa) => {
  return http.post("/auth/otp_wa", {
    wa,
  });
};

const activate_email = (email, kode) => {
  return http.post("/auth/activate_email", {
    email,
    kode,
  });
};

const activate_wa = (wa, kode) => {
  return http.post("/auth/activate_wa", {
    wa,
    kode,
  });
};

const update_password_email = (email, kode, password) => {
  return http.post("/auth/update_password_email", {
    email,
    kode,
    password,
  });
};

const update_password_wa = (wa, kode, password) => {
  return http.post("/auth/update_password_wa", {
    wa,
    kode,
    password,
  });
};

const updatePassword = (uuid, data) => {
  return http.put(`/auth/password/${uuid}`, data, { headers: authHeader() });
};

const logout = () => {
  localStorage.removeItem("user");
};

export default {
  register,
  otp_email,
  otp_wa,
  activate_email,
  activate_wa,
  update_password_email,
  update_password_wa,
  otp_wa,
  login,
  updatePassword,
  logout,
};
